<template>
  <div>
    <Popups />
    <AnswerPopups />
    <keep-alive :include="['AnswerAppView']">
      <router-view :key="$route.path + $route.query.t" />
    </keep-alive>
  </div>
</template>

<script>
import Popups from '@/components/PopupsNext'
import AnswerPopups from './popups'
// import { loadTCAD } from '@/plugin/TCAD'
export default {
  name: 'App',
  components: {
    Popups,
    AnswerPopups
  },
  mounted() {
    // loadTCAD('answer')
  }
}
</script>

<style lang="scss">
html {
  background-color: #ffffff;
}
body {
  background: #fff !important;
}
</style>
